export const CloseIcon = () => <i className="fa-regular fa-xmark-large" />
